import { Download } from 'lucide-react';

import { AppIcon, BRAND } from '@/components/Brand';
import { useOverlays } from '@/components/Overlays';
import { dismissInstallBanner, showsInstallInvite, usePwa } from '@/pwa/installState';
import { useStore } from '@/store/AppStore';

/**
 * Convite para instalar o Live Gospel (Dashboard e Minha agenda): aparece no celular — ou onde o
 * navegador oferece a instalação — até a pessoa instalar ou dizer "Agora não". Depois do
 * "Agora não", a instalação continua no menu do perfil.
 */
export default function InstallBanner() {
  const pwa = usePwa();
  const { openInstall } = useOverlays();
  const { actions } = useStore();

  if (!showsInstallInvite(pwa)) return null;

  return (
    <section
      aria-label="Instalar aplicativo"
      className="relative flex flex-wrap items-center gap-4 overflow-hidden rounded-card bg-sidebar px-5 py-4.5 text-sidebar-ink"
    >
      {/* O brilho é um gradiente, não um `blur`: o Safari não recorta filtro pelo canto
          arredondado do `overflow-hidden`, e o borrão vazava nos cantos da direita. */}
      <span
        aria-hidden
        className="pointer-events-none absolute -top-25 -right-25 size-90 rounded-pill bg-radial from-sidebar-accent/25 to-transparent to-70%"
      />
      <AppIcon className="relative size-13 rounded-block shadow-dialog" logoClassName="size-10" />
      <div className="relative min-w-52 flex-1">
        <p className="m-0 text-body-lg font-bold text-white">Instale o {BRAND.full} no seu celular</p>
        <p className="m-0 text-small text-sidebar-ink">
          Abra suas escalas com um toque, em tela cheia, e receba os avisos de confirmação.
        </p>
      </div>
      <div className="relative flex items-center gap-2">
        <button
          type="button"
          onClick={() => {
            dismissInstallBanner();
            actions.showToast('Tudo bem! Você pode instalar depois pelo menu do perfil.');
          }}
          className="h-9.5 rounded-control border border-sidebar-card-line px-3 text-small font-medium text-sidebar-ink hover:bg-sidebar-hover"
        >
          Agora não
        </button>
        <button
          type="button"
          onClick={openInstall}
          className="inline-flex h-9.5 items-center gap-1.5 rounded-control bg-sidebar-accent px-4 text-small font-bold text-sidebar hover:brightness-110"
        >
          <Download aria-hidden className="size-4 stroke-2" />
          Instalar
        </button>
      </div>
    </section>
  );
}
